<footer class="footer">
  <div class="footer__top">
    <div class="container">
      <div class="footer__grid">

        <!-- Brand -->
        <div class="footer__brand">
          <div class="footer-logo">
            <svg width="44" height="44" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
              <polygon points="50,4 53.5,50 50,42 46.5,50" fill="white"/>
              <polygon points="50,96 53.5,50 50,58 46.5,50" fill="white" opacity="0.6"/>
              <polygon points="96,50 50,46.5 58,50 50,53.5" fill="white" opacity="0.6"/>
              <polygon points="4,50 50,46.5 42,50 50,53.5" fill="white" opacity="0.6"/>
              <polygon points="79,21 53,50 56,47" fill="white" opacity="0.4"/>
              <polygon points="21,21 47,50 44,47" fill="white" opacity="0.4"/>
              <polygon points="79,79 53,50 56,53" fill="white" opacity="0.4"/>
              <polygon points="21,79 47,50 44,53" fill="white" opacity="0.4"/>
              <circle cx="50" cy="50" r="20" stroke="rgba(255,255,255,0.25)" stroke-width="1.2" fill="none"/>
              <circle cx="50" cy="50" r="30" stroke="rgba(255,255,255,0.12)" stroke-width="0.8" fill="none"/>
              <circle cx="50" cy="50" r="5.5" fill="white"/>
              <circle cx="50" cy="50" r="2.5" fill="#060b18"/>
            </svg>
            <div class="logo-text-block">
              <span class="logo-name">NAUTIS</span>
              <span class="logo-sub">VISION</span>
            </div>
          </div>
          <p>{{ t().footer_desc }}</p>
          <div class="footer__social">
            <a href="#" aria-label="LinkedIn">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2" fill="currentColor"/></svg>
            </a>
            <a href="#" aria-label="Instagram">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg>
            </a>
            <a href="#" aria-label="YouTube">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 00-1.95 1.96A29 29 0 001 12a29 29 0 00.46 5.58 2.78 2.78 0 001.95 1.95C5.12 20 12 20 12 20s6.88 0 8.59-.47a2.78 2.78 0 001.95-1.95A29 29 0 0023 12a29 29 0 00-.46-5.58z"/><polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="white"/></svg>
            </a>
          </div>
        </div>

        <!-- Links -->
        <div class="footer__col">
          <h4>{{ t().footer_col1 }}</h4>
          <ul>
            @for (l of links().solucoes; track l) {
              <li><a href="#">{{ l }}</a></li>
            }
          </ul>
        </div>

        <div class="footer__col">
          <h4>{{ t().footer_col2 }}</h4>
          <ul>
            @for (l of links().industrias; track l) {
              <li><a href="#">{{ l }}</a></li>
            }
          </ul>
        </div>

        <div class="footer__col">
          <h4>{{ t().footer_col3 }}</h4>
          <ul>
            @for (l of links().empresa; track l) {
              <li><a href="#">{{ l }}</a></li>
            }
          </ul>
        </div>

      </div>
    </div>
  </div>

  <div class="footer__bottom">
    <div class="container">
      <p>© {{ year }} {{ t().footer_copyright }}</p>
      <div class="footer__legal">
        <a href="#">{{ t().footer_privacy }}</a>
        <a href="#">{{ t().footer_terms }}</a>
        <a href="#">{{ t().footer_cookies }}</a>
      </div>
    </div>
  </div>
</footer>
